"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headBoxDesignSystemTheme = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var colours = _interopRequireWildcard(require("../colours"));

var _typography = require("../typography");

var _headBoxDesignSystemT;

var white = colours.white,
    black = colours.black,
    primary = colours.primary,
    glass = colours.glass,
    stainlessSteel = colours.stainlessSteel,
    carbon = colours.carbon,
    success = colours.success,
    text = colours.text,
    slate = colours.slate; // https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less

var headBoxDesignSystemTheme = (_headBoxDesignSystemT = {
  // colours:
  white: white,
  black: black,
  'primary-color': primary,
  'layout-body-background': glass,
  'heading-color': slate,
  'text-color': slate,
  'text-color-secondary': carbon,
  'body-background': glass,
  'layout-header-background': white,
  'info-color': primary,
  'success-color': success,
  // fonts:
  'font-family': _typography.montserrat,
  'font-size-base': '16px',
  'font-size-lg': '18px',
  'font-size-sm': '14px',
  'heading-1-size': '48px',
  'heading-2-size': '40px',
  'heading-3-size': '32px',
  'heading-4-size': '24px',
  'heading-5-size': '18px',
  'line-height-base': 1.4,
  // radiuses:
  'border-radius-base': '4px',
  'border-radius-sm': '4px',
  // vertical paddings
  'padding-lg': '32px',
  // containers
  'padding-md': '24px',
  // small containers and buttons
  'padding-sm': '16px',
  // Form controls and items
  'padding-xs': '8px',
  // small items
  'padding-xss': '4px',
  // vertical margins
  'margin-lg': '32px',
  // containers
  'margin-md': '24px',
  // small containers and buttons
  'margin-sm': '16px',
  // Form controls and items
  'margin-xs': '8px',
  // small items
  'margin-xss': '4px'
}, (0, _defineProperty2["default"])(_headBoxDesignSystemT, "margin-lg", '32px'), (0, _defineProperty2["default"])(_headBoxDesignSystemT, "margin-md", '16px'), (0, _defineProperty2["default"])(_headBoxDesignSystemT, "margin-sm", '12px'), (0, _defineProperty2["default"])(_headBoxDesignSystemT, "margin-xs", '8px'), (0, _defineProperty2["default"])(_headBoxDesignSystemT, "margin-xss", '4px'), (0, _defineProperty2["default"])(_headBoxDesignSystemT, 'height-base', '32px'), (0, _defineProperty2["default"])(_headBoxDesignSystemT, 'height-lg', '40px'), (0, _defineProperty2["default"])(_headBoxDesignSystemT, 'height-sm', '24px'), (0, _defineProperty2["default"])(_headBoxDesignSystemT, 'border-color-base', stainlessSteel), (0, _defineProperty2["default"])(_headBoxDesignSystemT, 'btn-border-radius-base', '4px'), _headBoxDesignSystemT);
exports.headBoxDesignSystemTheme = headBoxDesignSystemTheme;